
import { CountryDto } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { countryActions } from "./country.actions";

export interface CountryState {
    countries: CountryDto[] | null;
    nb: number;
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: CountryState = {
    countries: [],
    nb: 0,
    loading: true,
}

export const countryReducer = createReducer(
    initialeState,
    on(
        countryActions["[Country-API]LoadCountry"], state => ({
            ...state,
            loading: true
        })
    ),
    on(
        countryActions["[Country-API]LoadSuccess"], (state, res) => ({
            ...state,
            loading: false,
            countries: res.data?.countries ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        countryActions["[Country-API]LoadFailed"], (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        countryActions["[Country-API]ResetCountry"], state => ({
            ...state,
            loading: false,
            error: null,
            info: null,
            countries: null,
            warning: null
        })
    ),
)